import React from 'react';

function LoadingState() {
  return (
    <div className="mingo-loading-state" aria-busy="true" aria-live="polite">
      {[0, 1, 2].map((idx) => (
        <div key={idx} className="mingo-loading-state__card">
          <div className="mingo-loading-state__line mingo-loading-state__line--lg" />
          <div className="mingo-loading-state__line" />
          <div className="mingo-loading-state__line mingo-loading-state__line--sm" />
        </div>
      ))}
    </div>
  );
}

export default LoadingState;
